import {
  IconDashboard,
  IconUser,
  IconUsers,
  IconFileText,
  IconSettings,
  IconWallet,
  IconMail,
  IconBinaryTree2,
  IconBuilding,
  IconCreditCard
} from '@tabler/icons-react';

/**
 * Distributor Menu Configuration
 * 
 * Distributor users have access to:
 * - Dashboard (with distributor-specific data)
 * - Management (Resellers & Customers only - their own data)
 * - Subscriptions (view only - distributor's subscriptions)
 * - Orders (can place new orders and renewals)
 * - Campaigns (can manage campaigns)
 * - Credits (can add credits and view transaction history)
 * 
 * Distributors CANNOT access:
 * - Analytics (Owner only)
 * - Products & Plans (Owner only)
 */
const distributor = {
  id: 'distributor',
  title: 'Distributor',
  type: 'group' as const,
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'management',
      title: 'Management',
      type: 'collapse',
      icon: IconBuilding,
      children: [
        {
          id: 'resellers',
          title: 'Resellers',
          type: 'item',
          url: '/resellers',
          icon: IconBinaryTree2,
          breadcrumbs: false
        },
        {
          id: 'customers',
          title: 'Customers',
          type: 'item',
          url: '/customers',
          icon: IconUsers,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'subscriptions',
      title: 'Subscriptions',
      type: 'item',
      url: '/subscriptions',
      icon: IconFileText,
      breadcrumbs: false
    },
    {
      id: 'orders',
      title: 'Orders',
      type: 'item',
      url: '/orders',
      icon: IconWallet,
      breadcrumbs: false
    },
    {
      id: 'campaigns',
      title: 'Campaigns',
      type: 'item',
      url: '/campaigns',
      icon: IconMail,
      breadcrumbs: false
    },
    {
      id: 'credits',
      title: 'Credits',
      type: 'item',
      url: '/credits',
      icon: IconCreditCard,
      breadcrumbs: false
    },
    {
      id: 'profile',
      title: 'Profile',
      type: 'item',
      url: '/profile',
      icon: IconUser,
      breadcrumbs: false
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'item',
      url: '/settings',
      icon: IconSettings,
      breadcrumbs: false
    }
  ]
};

export default distributor;
